class AccessibilityControls {
  constructor() {
    this.storageKey = 'site-text-scale';
    this.scaleClasses = ['scale-100', 'scale-150', 'scale-200'];
    this.zoomValues = [1.0, 1.5, 2.0];
    this.currentScaleIndex = 0;
    this.init();
  }

  init() {
    this.restoreScale();
    this.attachEventListeners();
  }

  restoreScale() {
    const saved = localStorage.getItem(this.storageKey);
    if (saved) {
      const scaleIndex = parseInt(saved, 10);
      if (scaleIndex >= 0 && scaleIndex < this.scaleClasses.length) {
        this.currentScaleIndex = scaleIndex;
      } else {
        this.currentScaleIndex = 0;
      }
    } else {
      this.currentScaleIndex = 0;
    }
    this.applyScale(null);
  }

  attachEventListeners() {
    const buttons = document.querySelectorAll('.zoom-btn');
    buttons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const action = e.currentTarget.dataset.action;
        this.handleButtonClick(action, e.currentTarget);
      });
    });
  }

  handleButtonClick(action, clickedButton) {
    const prevScaleIndex = this.currentScaleIndex;

    if (action === 'decrease') {
      if (this.currentScaleIndex > 0) {
        this.currentScaleIndex--;
      }
    } else if (action === 'reset') {
      this.currentScaleIndex = 0;
    } else if (action === 'increase') {
      if (this.currentScaleIndex < this.scaleClasses.length - 1) {
        this.currentScaleIndex++;
      }
    }

    const prevZoom = this.zoomValues[prevScaleIndex];
    const newZoom = this.zoomValues[this.currentScaleIndex];
    const scrollY = window.scrollY;

    this.applyScale(clickedButton);

    if (prevZoom !== newZoom) {
      window.scrollTo(0, scrollY * (newZoom / prevZoom));
    }

    this.announceChange(action);
  }

  applyScale(clickedButton) {
    document.documentElement.classList.remove(...this.scaleClasses);
    document.documentElement.classList.add(this.scaleClasses[this.currentScaleIndex]);
    localStorage.setItem(this.storageKey, this.currentScaleIndex.toString());
    this.updateButtonStates(clickedButton);
  }

  updateButtonStates(clickedButton) {
    const buttons = document.querySelectorAll('.zoom-btn');
    const decreaseBtn = document.querySelector('[data-action="decrease"]');
    const increaseBtn = document.querySelector('[data-action="increase"]');

    buttons.forEach((btn) => {
      btn.classList.remove('active');
      btn.setAttribute('aria-pressed', 'false');
      btn.removeAttribute('disabled');
    });

    if (clickedButton) {
      clickedButton.classList.add('active');
      clickedButton.setAttribute('aria-pressed', 'true');
    } else {
      this._applyRestoredActiveState();
    }

    if (this.currentScaleIndex === 0 && decreaseBtn) {
      decreaseBtn.setAttribute('disabled', '');
    }
    if (this.currentScaleIndex === this.scaleClasses.length - 1 && increaseBtn) {
      increaseBtn.setAttribute('disabled', '');
    }
  }

  _applyRestoredActiveState() {
    const resetBtn = document.querySelector('[data-action="reset"]');
    const increaseBtn = document.querySelector('[data-action="increase"]');

    if (this.currentScaleIndex === 0) {
      if (resetBtn) {
        resetBtn.classList.add('active');
        resetBtn.setAttribute('aria-pressed', 'true');
      }
    } else {
      if (increaseBtn) {
        increaseBtn.classList.add('active');
        increaseBtn.setAttribute('aria-pressed', 'true');
      }
    }
  }

  announceChange(action) {
    const announcer = document.getElementById('zoom-audio-announcer');
    if (!announcer) return;

    const percentages = [100, 150, 200];
    const percentage = percentages[this.currentScaleIndex];

    if (action === 'reset') {
      announcer.textContent = 'Text size reset to standard 100%';
    } else if (action === 'increase') {
      announcer.textContent = `Text size zoomed to ${percentage}%`;
    } else if (action === 'decrease') {
      announcer.textContent = `Text size decreased to ${percentage}%`;
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new AccessibilityControls();
  });
} else {
  new AccessibilityControls();
}
